import React from 'react';
import { SearchContext } from '@vizsla/providers';
export function useSearch() {
    return React.useContext(SearchContext);
}
